import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { IconWrapperRounded } from "../../../components/IconWrapperRounded";

interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  header: string;
  children: React.ReactNode;
}

export const Banner = ({ icon, header, children }: BannerProps) => {
  return (
    <div
      className="d-flex flex-column align-items-start p-4 w-100 b-4px"
      style={{ backgroundColor: colors.ctaLight, gap: "16px" }}
    >
      <div
        className="d-flex flex-row align-items-center"
        style={{ gap: "16px" }}
      >
        <IconWrapperRounded
          backgroundColor={colors.ctaMain}
          color={colors.white}
        >
          {icon}
        </IconWrapperRounded>
        <StyledText color={colors.textPrimary} className="bodySubtextWide mb-0">
          {header}
        </StyledText>
      </div>
      <StyledText color={colors.textPrimary} className="headerTwo mb-0">
        {children}
      </StyledText>
    </div>
  );
};
